import { getAuthenticationHeaders } from "common/apis/APIUtility";
import { Storage } from "aws-amplify";
import elcos from "common/apis/ElcosAPI";

const OtaService = {
  uploadFile: async (file, target) => {
    const folder = `ota/bin/${target}`;
    const timestamp = new Date().getTime();

    await Storage.put(`${folder}/${timestamp}_${file.name}`, file, { contentType: file.type });
    return `${timestamp}_${file.name}`;
  },
  addInformation: async (data, fileName) => {
    const config = await getAuthenticationHeaders();
    const body = {data, fileName: fileName};
    console.log("DATA OTA: ", data)
    return await elcos.post("/ota/sessions", body, config);
  },
  getAll: async () => {
    const config = await getAuthenticationHeaders();
    return await elcos.get("/ota/sessions", config);
  },
};

export default OtaService